const r = / [a-zA-Z].+?="(.*?)"/g, o = / [a-zA-Z].+?='(.*?)'/g;
function c(e, n) {
  return e.replace(n, a(n));
}
function l(e) {
  let n = new RegExp("{{[^}]+}}", "g");
  return e ? e.replace(n, function(t) {
    return window.encodeURIComponent(t).replace("fallback%3A", "fallback:").replace(/'/g, "%27");
  }) : "";
}
function a(e) {
  let n = /%7B%7B.+%7D%7D/g, t;
  for (; t = n.exec(e); )
    try {
      e = e.replace(t[0], window.decodeURIComponent(t[0]));
    } catch {
      console.log("received an invalid URI component ", t[0]);
    }
  return e;
}
function i(e) {
  return e.replace(/<([^>]*)>/g, function(n, t) {
    return n.replace(t, l(t));
  });
}
function u(e) {
  return e.replace(r, c).replace(o, c);
}
export {
  a as decodeAttributes,
  u as decodeUriAttributes,
  l as encodeAttributes,
  i as encodeUriAttributes
};
